import { useCallback } from "react";
import { useLocation, useNavigate } from "./useRouter";
import { useSelector } from "react-redux";
import { useEventEmitter } from "../contexts/EventEmmiter";
import { RBAC_APPS } from "../constant/rbacConfig";
import { ROUTES } from "../constant/keyConstants";
import { sessionManager } from "../utils/utility";

export const useNewChat = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { emit } = useEventEmitter();
  const { selectedAgent } = useSelector((state) => state.state || {});

  const handleNewChat = useCallback(() => {
    const agentConfigMap = {
      [RBAC_APPS.GMT]: { path: ROUTES.GMT_CHAT, event: "newGMTChatDirect" },
      [RBAC_APPS.PROCUREMENT]: { path: ROUTES.PROCUREMENT_AI, event: "newProcurementChatDirect" },
      [RBAC_APPS.CHAT_GENIE]: { path: ROUTES.CHAT, event: "NewChatDirect" },
      [RBAC_APPS.DEEP_INSIGHTS]: { path: ROUTES.DEEP_INSIGHTS_CHAT, event: "newDeepInsightsChatDirect" },
      [RBAC_APPS.TALENT_PULSE_360]: { path: ROUTES.TALENT_PULSE_360, event: "newTalentPulseChatDirect" },
    };

    const currentPath = location?.pathname || "";
    let agentToUse;

    if (currentPath.startsWith(ROUTES.PROCUREMENT_AI)) {
      agentToUse = RBAC_APPS.PROCUREMENT;
    } else if (currentPath.startsWith(ROUTES.GMT_CHAT)) {
      agentToUse = RBAC_APPS.GMT;
    } else if (
      currentPath.startsWith(ROUTES.TALENT_PULSE_360) ||
      currentPath === ROUTES.TALENT_PULSE_360_ADMIN ||
      currentPath === ROUTES.TALENT_PULSE_360_SURVEY
    ) {
      agentToUse = RBAC_APPS.TALENT_PULSE_360;
    } else {
      agentToUse = selectedAgent || RBAC_APPS.CHAT_GENIE;
    }

    const config = agentConfigMap[agentToUse];
    if (config) {
      const isSubPage =
        currentPath === ROUTES.TALENT_PULSE_360_ADMIN ||
        currentPath === ROUTES.TALENT_PULSE_360_SURVEY;

      if (currentPath !== config.path && (!currentPath.startsWith(config.path) || isSubPage)) {
        navigate(config.path);
      }

      if (agentToUse === RBAC_APPS.TALENT_PULSE_360) {
        sessionManager.setSessionId(null, "talentPulse360SessionId");
      }

      emit(config.event, true);
    }
  }, [location.pathname, selectedAgent, navigate, emit]);

  const getSessionIdForAgent = useCallback((agent) => {
    if (!agent) return null;
    switch (agent) {
      case RBAC_APPS.CHAT_GENIE:
        return sessionManager.getSessionId("sessionId");
      case RBAC_APPS.TALENT_PULSE_360:
        return sessionManager.getSessionId("talentPulse360SessionId");
      case RBAC_APPS.GMT:
        return sessionManager.getSessionId("GMTSessionId");
      case RBAC_APPS.PROCUREMENT:
        return sessionManager.getSessionId("procAISessionId");
      case RBAC_APPS.DEEP_INSIGHTS:
        return sessionManager.getSessionId("deepInsightsSessionId");
      default:
        return null;
    }
  }, []);

  const activeSessionId = getSessionIdForAgent(selectedAgent);

  return {
    handleNewChat,
    getSessionIdForAgent,
    activeSessionId,
  };
};

